import { Box, IconButton, InputBase, Paper } from "@mui/material";
import React from "react";
import SendIcon from "@mui/icons-material/Send";

const ChatBox = ({ prompt, updatePrompt, onSend }) => {
  return (
    <Paper
      elevation={3}
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        onSend();
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        px: 2,
        py: 1,
        borderRadius: "30px",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.05)",
        bgcolor: "#fafafa",
      }}
    >
      <InputBase
        placeholder="Type a follow up message"
        value={prompt}
        onChange={(e) => updatePrompt(e.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            onSend();
          }
        }}
        sx={{
          ml: 1,
          flex: 1,
          fontSize: 14,
          color: "#444",
        }}
        inputProps={{ "aria-label": "type message" }}
      />

      <IconButton
        onClick={onSend}
        type="submit"
        sx={{
          backgroundColor: "#111",
          color: "white",
          ml: 1,
          width: 38,
          height: 38,
          "&:hover": {
            backgroundColor: "#000",
          },
        }}
      >
        <SendIcon fontSize="small" />
      </IconButton>
    </Paper>
  );
};

export default ChatBox;
